import { render, staticRenderFns } from "./BdrTableB2C.vue?vue&type=template&id=23d0da2b&scoped=true&"
import script from "./BdrTableB2C.vue?vue&type=script&lang=js&"
export * from "./BdrTableB2C.vue?vue&type=script&lang=js&"
import style0 from "./BdrTableB2C.vue?vue&type=style&index=0&id=23d0da2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0da2b",
  null
  
)

export default component.exports